import { Link } from "react-router-dom";
import { NAV_SERVICES } from "../lib/data";
import { useState } from "react";

function FooterGame() {
  const [selected, setSelected] = useState("");

  let message = "";
  if (selected === "Smart") {
    message = "Clearly. Otherwise you'd have clicked 'Get In Touch' by now. 💅";
  } else if (selected === "Clever") {
    message = "Not clever enough to have hired me yet, apparently. 🙃";
  } else if (selected === "Fool") {
    message = "Glad we agree. Now prove it and hire a proper designer. 🧠";
  }

  return (
    <div className="footer-game" style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11px', fontFamily: 'var(--font-mono)'}}>
      <span>Are you a</span>
      <select 
        onChange={(e) => setSelected(e.target.value)} 
        value={selected}
        style={{ 
          background: 'transparent', 
          border: '1px solid var(--gunmetal)', 
          color: 'var(--bright-snow)', 
          borderRadius: '4px',
          padding: '2px 4px',
          fontSize: '11px',
          outline: 'none',
          cursor: 'pointer'
        }}
      >
        <option value="" disabled>____</option>
        <option value="Fool" style={{color: '#000'}}>Fool</option>
        <option value="Smart" style={{color: '#000'}}>Smart</option>
        <option value="Clever" style={{color: '#000'}}>Clever</option>
      </select>
      <span>founder?</span>
      {message && <span style={{ marginLeft: '8px', color: '#ffb900', textTransform: 'none', letterSpacing: '0' }}>{message}</span>}
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container-x">
        <div className="footer-grid">
          <div>
            <Link to="/" className="footer-brand" data-testid="footer-brand">
              <img src="/logo.png" alt="Sinix Studio" style={{ height: 28, width: "auto", display: "block", filter: "invert(1) brightness(2)" }} />
              <span>Sinix Studio</span>
            </Link>
            <div className="tagline">Smarter Design. Stronger Brands.</div>
            <p>
              An AI-powered solo design studio in Mehsana — Brand Identity,
              UI/UX & Digital Content for ambitious teams that want a thoughtful
              partner, not a vendor.
            </p>
          </div>

          <div>
            <h5>// Studio</h5>
            <Link to="/work" className="footer-link">Work</Link>
            <Link to="/about" className="footer-link">About</Link>
            <Link to="/services" className="footer-link">Services</Link>
            <Link to="/industries" className="footer-link">Industries</Link>
            <Link to="/process" className="footer-link">Process</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>

          <div>
            <h5>// Services</h5>
            {NAV_SERVICES.map((s) => (
              <Link key={s.slug} to={`/services/${s.slug}`} className="footer-link">
                {s.label}
              </Link>
            ))}
          </div>

          <div>
            <h5>// Connect</h5>
            <a href="#" className="footer-link" data-testid="social-behance">Behance</a>
            <a href="https://www.linkedin.com/company/sinix-studio/" target="_blank" rel="noreferrer" className="footer-link" data-testid="social-linkedin">LinkedIn</a>
            <a href="https://www.instagram.com/sinixstudio.in/" target="_blank" rel="noreferrer" className="footer-link" data-testid="social-instagram">Instagram</a>
            <a href="https://x.com/achawalashubham" target="_blank" rel="noreferrer" className="footer-link" data-testid="social-twitter">Twitter</a>
            <a href="https://dribbble.com/shubhamprajapati-hello" target="_blank" rel="noreferrer" className="footer-link" data-testid="social-dribbble">Dribbble</a>
            <a href="https://wa.me/919106276865" target="_blank" rel="noreferrer" className="footer-link" data-testid="social-whatsapp">WhatsApp</a>
            <a href="mailto:sinixstudio.in@gmail.com" className="footer-link" data-testid="social-email">Email</a>
          </div>
        </div>


        <div className="footer-bottom" style={{ alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <span>© {new Date().getFullYear()} Sinix Studio. All rights reserved.</span>
            <span>Designed &amp; built by Shubham Prajapati, Mehsana</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
            <Link
              to="/game"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '7px',
                background: 'transparent',
                color: 'var(--bright-snow)',
                border: '1px solid rgba(255,255,255,0.25)',
                borderRadius: '999px',
                padding: '8px 18px',
                fontFamily: 'var(--font-mono)',
                fontSize: '11px',
                fontWeight: '600',
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                textDecoration: 'none',
                transition: 'all 0.25s ease',
                whiteSpace: 'nowrap',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = 'var(--bright-snow)';
                e.currentTarget.style.color = 'var(--carbon-black)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = 'var(--bright-snow)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              🎮 Let&apos;s play game
            </Link>
            <FooterGame />
          </div>
        </div>

      </div>
    </footer>
  );
}
